export default "__VITE_ASSET__DwQFwX9n__"